export type { NotificationDto as Notification } from "./generated/NotificationDto";
export type { NotificationInboxDto as NotificationInbox } from "./generated/NotificationInboxDto";

/** Inbox filter — maps to the server's `?filter=` query param. SPA-only union
 *  (the server parses these snake_case codes). */
export type NotificationFilter = "unread" | "all" | "approvals" | "alerts";

export const NOTIFICATION_FILTER_LABELS: Record<NotificationFilter, string> = {
  unread: "Unread",
  all: "All",
  approvals: "Approvals",
  alerts: "Alerts",
};

/** Notifications whose `event_type` is this code are agent-run approval
 *  checkpoints — the "Needs you" group with inline Approve/Reject. */
export const CHECKPOINT_EVENT_TYPE = "agent_run.checkpoint";

/** Notifications whose `event_type` is this code are agent-run human-in-the-loop
 *  steps — the "Needs you" group with inline Mark done / Skip. */
export const HITL_EVENT_TYPE = "agent_run.hitl";

/** Both event types that belong in the inbox "Needs you" group. */
export const NEEDS_YOU_EVENT_TYPES: readonly string[] = [
  CHECKPOINT_EVENT_TYPE,
  HITL_EVENT_TYPE,
];
